var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThankyoupagedesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236.572,
    height: 236.183,
    viewBox: "0 0 236.572 236.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_369",
    x: 0,
    y: 0,
    width: 236.572,
    height: 236.183,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 14,
    dy: 14,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(-5352 -12016)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5352, 12016)",
    filter: "url(#Path_369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369-2",
    "data-name": "Path 369",
    d: "M275.93,133.606c-26.159,17.544-64.761,59.21-79.952,91.925-12.494-17.713-24.05-33.407-42.226-48.246-8.76-7.153-19.563,6.088-10.806,13.237,19.646,16.04,34.171,31.588,46.558,50.877a8.857,8.857,0,0,0,15.606-1.34c13.08-30.937,46.236-74.556,70.631-95.04h0c15.907,26.766,18.3,61.535.208,92.293-35.354,60.116-121.695,59.725-156.565-.672-34.878-60.413,8.72-135.927,78.478-135.927a89.372,89.372,0,0,1,59.544,22.2,3.2,3.2,0,0,0,4.458-.218l.044-.048a3.208,3.208,0,0,0-.219-4.6,95.828,95.828,0,0,0-65.139-23.806c-74.5.941-120.026,81.1-82.771,145.63,37.37,64.727,130.8,64.726,168.167,0C302.107,204.96,298.254,163.934,275.93,133.606Z",
    transform: "translate(-93.51 -87.24)",
    fill: "#ecf1f2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyoupagedesktop);
export default __webpack_public_path__ + "static/media/Thankyou page desktop.981d46fc6756c94d6b27c549c99673fe.svg";
export { ForwardRef as ReactComponent };